import React from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const VideoModal = ({ isOpen, onClose, videoSrc, isYoutube }) => {
  // Handle click outside to close
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={handleBackdropClick}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="relative max-w-6xl w-[95%] aspect-video bg-black rounded-xl shadow-2xl"
          >
            {/* Close Button */}
            <motion.button
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              onClick={onClose}
              className="absolute -top-12 right-0 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all duration-300 group"
            >
              <X className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
            </motion.button>

            {/* Video Container */}
            <div className="w-full h-full rounded-xl overflow-hidden">
              {isYoutube ? (
                <iframe
                  src={videoSrc}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <video
                  src={videoSrc}
                  className="w-full h-full"
                  controls
                  autoPlay
                  controlsList="nodownload" // Prevents download button
                  playsInline
                >
                  Your browser does not support video playback.
                </video>
              )}
            </div>

            {/* Loading State */}
            <div className="absolute inset-0 flex items-center justify-center">
              <motion.div
                initial={{ opacity: 1 }}
                animate={{ opacity: 0 }}
                transition={{ delay: 0.5 }}
                className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"
              />
            </div>
          </motion.div>

          {/* Keyboard Instructions */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-white/60 text-sm"
          >
            Press ESC to close
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoModal;